/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import { DOWN_DISTANCE_VALUES, FIELD_ZONE_VALUES } from '../constants/filters';
import { DOWN_AND_DISTANCE_KEY } from '../state/selectors/filters';

// eslint-disable-next-line import/prefer-default-export
export function extractFilters(data) {
  if (!data) return {};
  if (!data.length > 0) return {};

  const filters = {};
  for (let i = 0, ii = data.length; i < ii; i += 1) {
    filters[data[i].name] = data[i].filterData;
  }
  return filters;
}

export function isReadyForInsert(type, filter) {
  if (filter.length === 0) return true;
  const dict = type === DOWN_AND_DISTANCE_KEY ? DOWN_DISTANCE_VALUES : FIELD_ZONE_VALUES;
  for (let i = 0, ii = dict.length; i < ii; i += 1) {
    if (!filter[dict[i]]) return false;
  }
  return true;
}

export function getUniqueDownDistanceValues(userSelections, possibleSelections) {
  const selections = [];
  for (const key in userSelections) {
    const reqDown = +userSelections[key].down;
    const reqMin = +userSelections[key].min;
    const reqMax = +userSelections[key].max || 'max';
    for (let i = 0, ii = possibleSelections.length; i < ii; i += 1) {
      const split = possibleSelections[i].split('-');
      const down = +split[0];
      const distance = +split[1];
      if (down === reqDown && distance >= reqMin && (reqMax === 'max' || distance <= reqMax)) {
        selections.push(possibleSelections[i]);
      }
    }
  }
  return selections;
}

export function getUniqueFieldZoneValues(userSelections, possibleSelections) {
  const selections = [];
  for (const key in userSelections) {
    const reqMin = +userSelections[key].min;
    const reqMax = +userSelections[key].max;
    for (let i = 0, ii = possibleSelections.length; i < ii; i += 1) {
      const distance = +possibleSelections[i];
      if (distance >= reqMin && distance <= reqMax) {
        selections.push(distance);
      }
    }
  }
  return selections;
}
